import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ListSnippetItem } from "../list-snippet-item/list-snippet-item";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { navCard, snippets } from "../../../data/car-care";
import { NavCard } from "../nav-card/nav-card";
import { parentLinks } from "../../../data/parent-menu";
import styles from "./car-care-menu.module.css";
export var CarCareMenu = function(param) {
    var isMobile = param.isMobile;
    var ref = useContext(SharedUiHeaderV2Context), handleTrackEvent = ref.logicStore.handleTrackEvent, isGapMenuItemShown = ref.isGapMenuItemShown, isUpdatedCinchCareCopy = ref.isUpdatedCinchCareCopy;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                children: /*#__PURE__*/ _jsx("ul", {
                    className: styles.list,
                    children: snippets.filter(filterCopy(isUpdatedCinchCareCopy, isGapMenuItemShown)).map(function(snippet) {
                        return /*#__PURE__*/ _jsx(ListSnippetItem, {
                            isMobile: isMobile,
                            heading: snippet.heading,
                            snippet: snippet.snippet,
                            linkText: snippet.linkText,
                            href: snippet.href,
                            handleTrackEvent: function() {
                                return handleTrackEvent({
                                    name: "click",
                                    category: "mega menu",
                                    label: parentLinks.CARCARE,
                                    action: snippet.heading
                                });
                            }
                        }, snippet.heading);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.carCareNavCard,
                children: /*#__PURE__*/ _jsx(NavCard, {
                    heading: navCard.heading,
                    subHeading: navCard.body,
                    link: navCard.sectionLink,
                    href: navCard.href,
                    imageSrc: navCard.image,
                    alt: navCard.alt,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARCARE,
                            action: navCard.heading
                        });
                    }
                })
            })
        ]
    });
};
/**
 * a Curried function to help simplify the filter function
 * @param useUpdatedCinchCareCopy
 * @param isGapMenuItemShown
 * @returns {(snippet: NavItemSnippet) => boolean} filterFn
 */ export function filterCopy(useUpdatedCinchCareCopy, isGapMenuItemShown) {
    return function(snippet) {
        // if the env var is set to true, show the gap insurance menu item
        if (snippet.heading === "GAP insurance") {
            return isGapMenuItemShown;
        }
        // if the env var is set to true, hide the original copy...
        if (snippet.heading === "Warranty, servicing & breakdown") {
            return !useUpdatedCinchCareCopy;
        }
        // ...and show the new copy
        if (snippet.heading === "Servicing, warranty and breakdown") {
            return useUpdatedCinchCareCopy;
        }
        // don't filter anything else...
        return true;
    };
}
